module.exports = __webpack_public_path__ + "static/media/11.d69755e0.JPG";